import moment from "moment";

export const buildStoreRequisitionPayload = (values, styleDetails) => {
  const hasBuyer = Boolean(values.buyer_id);
  const hasFactory = Boolean(values.sub_contract_factory_id);

  return {
    buyer_id: hasFactory ? null : values.buyer_id || null,
    sub_contract_factory_id: hasBuyer ? null : values.sub_contract_factory_id || null,
    line_id: values.line_id || null,
    entry_date: values.entry_date
      ? moment(values.entry_date).format("YYYY-MM-DD")
      : null,
    requisition_no: values.requisition_no || null,
    movement_type: values.movement_type || null,
    sr_type: values.sr_type || null,
    status: values.status || "pending",
    note: values.note || null,
    style_details: styleDetails.map((style) => ({
      id: style.id || 0,
      style_id: style.style_id,
      sales_contract_id: style.sales_contract_id,
      buying_office_id: style.buying_office_id || null,
      po_map_id: style.po_map_id || null,
      is_delete: style.is_delete || 0,
      items: (style.items || []).map((item) => ({
        id: item.id || 0,
        item_category_id: item.item_category_id,
        item_id: item.item_id,
        sub_style_id: item.sub_style_id || null,
        color_id: item.color_id || null,
        unit_id: item.unit_id || null,
        order_qty: item.order_qty ?? null,
        qty: item.qty,
        convertion_unit_id: item.convertion_unit_id || null,
        convertion_rate: item.convertion_rate ?? null,
        roll_qty: item.roll_qty ?? null,
        is_delete: item.is_delete || 0,
      })),
    })),
  };
};
